var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"detail-box"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"返回","placement":"top-start"}},[_c('i',{staticClass:"iconfont icon-fanhui1",on:{"click":function($event){return _vm.$router.go(-1)}}})]),_c('route-title'),_c('soft-ware-detail')],1),_c('bottom-slider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }